"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getViewId = exports.getSessionHit = exports.getSdkVersion = exports.setPrevPageType = exports.setPrevPageName = exports.getPrevPageType = exports.getPrevPageName = void 0;
var firefly_utilities_helper_ts_1 = require("firefly-utilities-helper-ts");
var firefly_utilities_ts_1 = require("firefly-utilities-ts");
var firefly_shared_ts_1 = require("firefly-shared-ts");
var pjson = require('../../version.json');
function getPrevPageName(persistMethod) {
    return firefly_utilities_ts_1.FFPersistenceManager.getSessionValue('prevPageName', persistMethod);
}
exports.getPrevPageName = getPrevPageName;
function getPrevPageType(persistMethod) {
    return firefly_utilities_ts_1.FFPersistenceManager.getSessionValue('prevPageType', persistMethod);
}
exports.getPrevPageType = getPrevPageType;
function setPrevPageName(json, persistMethod) {
    var pageName = '';
    if ((0, firefly_utilities_helper_ts_1.isObject)(json.appState) && (0, firefly_utilities_helper_ts_1.isDefined)(json.appState.pageName)) {
        pageName = json.appState.pageName;
    }
    else if ((0, firefly_utilities_helper_ts_1.isObject)(json.view) && (0, firefly_utilities_helper_ts_1.isDefined)(json.view.name)) {
        pageName = json.view.name;
    }
    firefly_utilities_ts_1.FFPersistenceManager.setSessionValue('prevPageName', pageName, persistMethod);
}
exports.setPrevPageName = setPrevPageName;
function setPrevPageType(json, persistMethod) {
    var pageType = '';
    if ((0, firefly_utilities_helper_ts_1.isObject)(json.appState) && (0, firefly_utilities_helper_ts_1.isDefined)(json.appState.pageType)) {
        pageType = json.appState.pageType;
    }
    else if ((0, firefly_utilities_helper_ts_1.isObject)(json.view) && (0, firefly_utilities_helper_ts_1.isDefined)(json.view.type)) {
        pageType = json.view.type;
    }
    firefly_utilities_ts_1.FFPersistenceManager.setSessionValue('prevPageType', pageType, persistMethod);
}
exports.setPrevPageType = setPrevPageType;
function getSdkVersion() {
    var sdkVersion = '';
    if ((0, firefly_utilities_helper_ts_1.isString)(pjson.version) && !(0, firefly_utilities_helper_ts_1.isEmptyString)(pjson.version)) {
        sdkVersion = pjson.version;
    }
    return sdkVersion;
}
exports.getSdkVersion = getSdkVersion;
function getSessionHit(persistMethod) {
    var sessionHit;
    var sessionHitCookie = firefly_utilities_ts_1.FFPersistenceManager.getSessionValue('sessionHit', persistMethod);
    sessionHit = firefly_utilities_ts_1.Utilities.getNumberOrDefault(sessionHitCookie);
    sessionHit += 1;
    firefly_utilities_ts_1.FFPersistenceManager.setSessionValue('sessionHit', sessionHit.toString(), persistMethod);
    return sessionHit.toString();
}
exports.getSessionHit = getSessionHit;
function getViewId(persistMethod) {
    var viewId = firefly_utilities_ts_1.FFPersistenceManager.getSessionValue('viewId', persistMethod);
    if (!(0, firefly_utilities_helper_ts_1.isString)(viewId) || (0, firefly_utilities_helper_ts_1.isEmptyString)(viewId)) {
        viewId = firefly_shared_ts_1.Event.createViewId();
        firefly_utilities_ts_1.FFPersistenceManager.setSessionValue('viewId', viewId, persistMethod);
    }
    return viewId;
}
exports.getViewId = getViewId;
